"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WHITESPACE_PATTERN = /\s/g;
exports.FORMAT_3_DIGITS_GROUPS = /\B(?=(\d{3})+(?!\d))/g;
//# sourceMappingURL=RegExpUtils.js.map